import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdQueuesRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-queues',
	path: '/projects/:projectKey/queues/:custom(custom)?/:id?',
};
